<script lang="ts">
import VSwitch           from '@/lib/components/VSwitch/VSwitch.vue';

export default defineComponent({
	name: "TogglesSample",

	components : {
		VSwitch
	},

	data() {
		return {
			switchModel: false
		}
	}
});
</script>

<template>
	<VSwitch v-model="switchModel" />
</template>

